import React, { useState, useEffect } from "react";
import Snackbar from "@material-ui/core/Snackbar";
import { Alert } from "@material-ui/lab";
import * as Icon from "react-feather";

import {
  Button,
  Card,
  CardActions,
  CardContent,
  TextField,
  Select,
  MenuItem,
  CircularProgress,
  Modal,
  Typography,
  Box,
} from "@material-ui/core";
//Validators
import { useFormik } from "formik";
import * as yup from "yup";
//
import useStyles from "./AssetVersionNewAssetModal.styles";
import { Asterisk } from "phosphor-react";
import { fget, fpost, exportFileWithXhr } from "../../../API/callsAPI";
import { useHistory } from "react-router-dom";
import DragScreen from "../../Utilities/DragScreen/DragScreen";
import UploadFile from "../../Utilities/UploadFile/UploadFile";
import ModalTitleAndButtons from "../../Utilities/ModalTitleAndButtons/ModalTitleAndButtons.component";
import ConfirmDeleteFile from "../../Utilities/ConfirmDeleteFile/ConfirmDeleteFile.component";
import HelperText from "../../Utilities/HelperText/HelperText";
import commonStyles from "../../../Utils/commonStyles";
import CustomInputFieldWithFormik from "../../Utilities/CustomInputFields/CustomInputFieldWithFormik";

const AssetVersionNewVersionModal = (props) => {
  const classes = useStyles();
  const commonClasses = commonStyles();
  const history = useHistory();
  const [file, uploadFileSet] = useState();
  const [fileTouched, setFileTouched] = useState(false);
  const [fileUploading, setFileUploading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [selectedTask, setSelectedTask] = useState();
  const [deleteFileModal, setDeleteFileModal] = useState(false);
  const [dataEntryFieldType, setDataEntryFieldType] = useState("default");

  useEffect(() => {
    // fetching the tasks only if the taskList is empty
    // if its fetched in edit modal no need to make the api call again
    !props.taskList.length && props.fetchTasks();
  }, []);

  const displaySelectedFile = (event) => {
    let file = event.target.files[0];
    event.target.value = null;
    uploadFileSet(file);
    setFileTouched(true);
  };

  const handleClearUpload = (event) => {
    event?.stopPropagation();
    uploadFileSet(null);
    setFileTouched(false);
    setDeleteFileModal(false);
  };

  const [snackValue, setSnackValue] = React.useState({
    isOpen: false,
    message: "",
    isError: false,
  });

  const getInitialValues = () => {
    return props.customFields?.reduce((acc, field) => {
      acc[field.name] = field.default_value || "";
      return acc;
    }, {});
  };

  //Validators
  const NewAssetVersionValidationScheme = yup.object({
    assetVersionName: yup
      .string("String required")
      .min(1, "Too Short!")
      .max(50, "Maximum Character Limit: 50")
      .required("This is required field"),
  });

  const formik = useFormik({
    //add initail values for editing a version
    initialValues: {
      assetVersionName: "",
      status: "",
      ...getInitialValues(),
    },
    validationSchema: NewAssetVersionValidationScheme,
    onSubmit: async (values) => {
      setLoader(true);
      if (fileTouched) {
        setFileUploading(true);
      }
      let formdata = new FormData();
      Object.keys(values).forEach((key) => {
        if (values[key] !== undefined && values[key] !== null) {
          formdata.append(key, values[key]);
        }
      });
      formdata.append("name", values.assetVersionName);
      if (file) {
        formdata.append("file_name", file.name);
      }
      formdata.append("project", props.projectId);
      formdata.append("status", values.status);
      formdata.append("asset", props.assetID);
      selectedTask && formdata.append("task", selectedTask);

      let newVersion = {
        url: "trackables/asset-version/v2/",
        data: formdata,
      };
      try {
        const newVersionRes = await fpost(newVersion);
        if (newVersionRes.status === 200 || 201) {
          if (file) {
            getSignedUrl(newVersionRes.data.id);
          } else {
            setLoader(false);
            setSnackValue({
              isOpen: true,
              message: `SuccessFully Created ${newVersionRes.data.name}`,
              isError: false,
            });
            setFileUploading(false);
            props.updateRefreshCounter();
            props.handleNewAssetVersionModalState();
          }
        }
      } catch (error) {
        setLoader(false);
        setFileUploading(false);
        setSnackValue({
          isOpen: true,
          message: `${error}`,
          isError: true,
        });
      }
    },
  });

  function updateProgressBar(e) {
    if (e.lengthComputable) {
      var percentComplete = parseInt((e.loaded / e.total) * 100);
      setUploadProgress(percentComplete);
    }
  }

  function transferComplete(evt) {
    setSnackValue({
      isOpen: true,
      message: `File transfered SuccessFully `,
      isError: false,
    });
  }

  function transferFailed(evt) {
    setSnackValue({
      isOpen: true,
      message: `Transfer Failed`,
      isError: true,
    });
  }

  // function transferCanceled(evt) {
  //   setSnackValue({
  //     isOpen: true,
  //     message: `File Transfer Cancelled`,
  //     isError: true,
  //   });
  // }
  const getSignedUrl = async (newId) => {
    let assetVersionClass = props.trackableClassList.find(
      (el) => el.model === "assetversion"
    );
    try {
      const uploadUrl = await fget({
        url: `trackables/${assetVersionClass.model}/${newId}/upload`,
      });
      if (uploadUrl.status === 200) {
        await exportFileWithXhr({
          url: uploadUrl.data?.signed_url,
          data: file,
          updateProgressBar: (e) => {
            updateProgressBar(e);
          },
          transferComplete: transferComplete(),
          transferFailed: transferFailed(),
          // transferCanceled: transferCanceled(),
        });
        fget({
          url: `trackables/${assetVersionClass.model}/${newId}/thumbnail`,
        });
        setLoader(false);
        props.handleUpdatedFileForParent(file);
        setSnackValue({
          isOpen: true,
          message: `SuccessFully Created`,
          isError: false,
        });
        setFileUploading(false);
        props.updateRefreshCounter();
        props.handleNewAssetVersionModalState();
      }
    } catch (error) {
      setLoader(false);
      setFileUploading(false);
      setSnackValue({
        isOpen: true,
        message: `${error}`,
        isError: true,
      });
    }
  };

  const handleDragFile = (e) => {
    if (e.type == "dragenter") {
      //when  file enter- display dragscreen
      props.handleDragScreen(true);
      props.setDragFileEnterModal(true);
    }
    //catching the dragged file for uploading
    if (e.type === "drop") {
      props.handleDragScreen(false);
      uploadFileSet(e.dataTransfer.files[0]);
      setFileTouched(true);
    }
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <div className={classes.root}>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={snackValue.isOpen}
        autoHideDuration={2000}
        onClose={() => setSnackValue({ isOpen: false, message: "" })}
        // message={`${snackValue.message}`}
      >
        <Alert severity={snackValue.isError === false ? "success" : "warning"}>
          {snackValue.message}
        </Alert>
      </Snackbar>
      <Card
        className={classes.card}
        onDragEnter={(e) => handleDragFile(e)}
        onDrop={(e) => handleDragFile(e)}
        onDragLeave={(e) => handleDragFile(e)}
        onDragOver={(e) => handleDragFile(e)}
      >
        <CardContent className={classes.cardContent}>
          <DragScreen dragScreen={props.dragScreen} />
          <form onSubmit={formik.handleSubmit}>
            <ModalTitleAndButtons
              name="Version"
              type="New"
              closeModal={() => {
                props.handleNewAssetVersionModalState();
              }}
            />
            <div
              style={{
                marginTop: "8px",
                display: "flex",
                alignItems: "center",
                gap: "16px",
              }}
            >
              <Button
                onClick={() => setDataEntryFieldType("default")}
                className={
                  dataEntryFieldType === "default"
                    ? classes.selectedButton
                    : classes.defaultButton
                }
              >
                Default fields(5)
              </Button>
              <Button
                onClick={() => setDataEntryFieldType("custom")}
                className={
                  dataEntryFieldType === "custom"
                    ? classes.selectedButton
                    : classes.defaultButton
                }
              >
                Custom fields({props.customFields?.length})
              </Button>
            </div>
            {dataEntryFieldType === "default" && (
              <div className={classes.cardContentDiv1}>
                <div style={{ marginTop: "5px" }}>
                  <span>Version Name</span>
                  <Asterisk size={12} color="#FF0000" weight="fill" />
                  <div
                    className={classes.cardContentDiv2}
                    style={{ marginTop: "5px" }}
                  >
                    <TextField
                      fullWidth
                      type="text"
                      id="versionName"
                      className={classes.cardContentInput1}
                      InputProps={{ disableUnderline: true }}
                      placeholder="Enter a Version Name"
                      name="assetVersionName"
                      value={formik.values.assetVersionName}
                      onChange={formik.handleChange}
                      error={Boolean(formik.errors.assetVersionName)}
                    />
                  </div>
                  {formik.errors.assetVersionName &&
                  formik.touched.assetVersionName ? (
                    <HelperText text={formik.errors.assetVersionName} />
                  ) : null}
                </div>
                <div
                  className={classes.displayFlex}
                  style={{ marginTop: "25px" }}
                >
                  <div style={{ width: "150px" }}>
                    <span>Status</span>
                    <div
                      className={classes.cardContentDiv2}
                      style={{ marginTop: "5px" }}
                    >
                      <Select
                        style={{ width: "100%" }}
                        id="selectStatusV"
                        label="Select Status"
                        name="status"
                        className={classes.cardContentInput1}
                        disableUnderline
                        value={formik.values.status}
                        onChange={formik.handleChange}
                        MenuProps={{
                          classes: {
                            paper: classes.dropDown,
                          },
                        }}
                      >
                        <MenuItem
                          className={classes.addNewStatusButton}
                          onClick={() => {
                            history.push(`/${props.projectId}/settings/status`);
                          }}
                        >
                          <Icon.Plus />
                          Add new Status
                        </MenuItem>
                        <MenuItem value="">None</MenuItem>
                        {props.status &&
                          props.status.map((eachStatus) => (
                            <MenuItem value={eachStatus.id}>
                              <span
                                style={{
                                  height: "15px",
                                  width: "15px",
                                  backgroundColor: `rgb(${eachStatus?.color})`,
                                  borderRadius: "50%",
                                  display: "inline-block",
                                  margin: "0px 5px",
                                }}
                              ></span>
                              {eachStatus.name} - {eachStatus.code}
                            </MenuItem>
                          ))}
                      </Select>
                    </div>
                  </div>
                  <div style={{ maxWidth: "50%" }}>
                    <span>Status Code</span>
                    <div
                      style={{ marginTop: "5px" }}
                      className={classes.cardContentDiv2}
                    >
                      <TextField
                        className={classes.cardContentInput1}
                        InputProps={{
                          disableUnderline: true,
                          style: { opacity: "0.4" },
                        }}
                        disabled
                        fullWidth
                        value={
                          props.status.find(
                            (eachStatus) =>
                              eachStatus.id === formik.values.status
                          )?.code
                        }
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <span style={{ display: "block", margin: "25px 0 5px 0" }}>
                    Link to Task
                  </span>
                  <Select
                    style={{ width: "100%" }}
                    id="linkToTask"
                    label="Link to Task"
                    name="Link to Task"
                    className={classes.cardContentDiv2}
                    disableUnderline
                    value={selectedTask}
                    MenuProps={{
                      classes: {
                        paper: classes.dropDown,
                      },
                    }}
                    onChange={(e) => setSelectedTask(e.target.value)}
                  >
                    <MenuItem>None</MenuItem>
                    {props.taskList &&
                      props.taskList.map((task) => (
                        <MenuItem value={task.id}>{task.name}</MenuItem>
                      ))}
                  </Select>
                </div>

                <div
                  style={{
                    marginTop: "25px",
                  }}
                >
                  Attachment
                  <UploadFile
                    fileUploading={fileUploading}
                    uploadProgress={uploadProgress}
                    thumbnail={file}
                    handleClearUpload={handleClearUpload}
                    handleThumbnailUpload={displaySelectedFile}
                    setDeleteFileModal={setDeleteFileModal}
                  />
                </div>
              </div>
            )}
            {dataEntryFieldType === "custom" && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                  marginTop: "8px",
                  minHeight: "200px",
                }}
              >
                {props.customFields?.length &&
                  props.customFields.map((sin) =>
                    sin.type === "media" ? (
                      ""
                    ) : sin.type === "dropdown" ? (
                      <Box key={sin.name}>
                        <Typography>{sin?.name}</Typography>
                        <div className={commonClasses.dropdownContainer}>
                          <Select
                            style={{ width: "100%" }}
                            disableUnderline
                            className={commonClasses.select}
                            value={formik.values[sin?.name]}
                            onChange={(e) =>
                              formik.setFieldValue(sin?.name, e.target.value)
                            }
                          >
                            {sin?.options?.length &&
                              sin?.options?.map((option) => (
                                <MenuItem key={option} value={option}>
                                  {option}
                                </MenuItem>
                              ))}
                          </Select>
                        </div>
                        {formik.touched[sin.name] &&
                          formik.errors[sin.name] && (
                            <Typography color="error">
                              {formik.errors[sin.id]}
                            </Typography>
                          )}
                      </Box>
                    ) : (
                      <CustomInputFieldWithFormik
                        key={sin.name}
                        name={sin.name}
                        formik={formik}
                        isRequired={false}
                        label={sin.name}
                        isDisabled={false}
                      />
                    )
                  )}
              </Box>
            )}
            <br />

            <CardActions className={classes.cardAction}>
              <Button
                className={classes.done}
                type="submit"
                value="Submit"
                size="small"
                disabled={fileUploading}
              >
                {loader ? (
                  <CircularProgress style={{ width: "25px", height: "25px" }} />
                ) : (
                  "Create New Version"
                )}
              </Button>
            </CardActions>
          </form>
        </CardContent>
      </Card>
      <div>
        <Modal
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          open={deleteFileModal}
          onClose={() => setDeleteFileModal(false)}
        >
          <ConfirmDeleteFile
            name={typeof file === "object" ? file?.name : file}
            closeModal={() => {
              setDeleteFileModal(false);
            }}
            deleteFile={() => {
              handleClearUpload();
            }}
          />
        </Modal>
      </div>
    </div>
  );
};

export default AssetVersionNewVersionModal;
